
import CustomerModel from './customer.model.js';

class TourModel {
	experience = {};

	prices = [];

	extras = [];

	schedule = {};

	customer= {};

	selectedMethod = '';

	acceptPrivacyPolicy = false;

	stripeToken = null;

	constructor({
		experience = {},
		prices = [],
		extras = [],
		schedule = {},
		customer = new CustomerModel({}),
		selectedMethod = 'email',
		acceptPrivacyPolicy = false,
		stripeToken = null,
	}) {
		this.experience = experience;
		this.prices = prices;
		this.extras = extras;
		this.schedule = schedule;
		this.customer = customer;
		this.selectedMethod = selectedMethod;
		this.acceptPrivacyPolicy = acceptPrivacyPolicy;
		this.stripeToken = stripeToken;
	}
}

export default TourModel;
